module.exports = {
    "id": "hat",
    "title": "hat",
    "image": "provision/parts/hat/hat.png",
    "info": [
      {
        "text": "It's a hat! <br> <br> Try it on with the pin to piece <i class='icon icon-pushpin blue'></i> sticker",
        "image": "provision/parts/hat/hat.png"
      }
    ],
    "exposedVariables": [],
    "codeImage": ""
  };